import AuthGuard from "components/auth/AuthGuard";
import MobileDeviceCheck from "components/mobile/MobileDeviceCheck";
import Header from "./elements/Header/Header";
import SideNav from "./elements/SideNav/SideNav";

export default function HeaderAndNavLayout({
  children,
  showNav = true,
}: React.PropsWithChildren<{ showNav?: boolean }>) {
  return (
    <AuthGuard>
      <MobileDeviceCheck>
        <div className="flex h-screen items-stretch gap-4 px-5 py-3">
          {showNav && <SideNav className="shrink-0" />}
          <div className="flex min-h-0 flex-1 flex-col items-stretch">
            <Header />
            {children}
          </div>
        </div>
      </MobileDeviceCheck>
    </AuthGuard>
  );
}
